import { TemplateTypes } from "../Enum/TemplateTypes";
import * as envConfig from "./env-config";

const IS_DEV = process.env.NODE_ENV === 'development';

export const configs = {
  widgetConfigDefaults: {
    currency: "AUD",
    priceFormat: "%[,###.##]",
    numberFormat: ",###.",
    dateFormat: "dd/mm/yyyy",
    saveProgressEnabled: true,
    hideFinishCta: envConfig.PX_HIDE_FINISH,
    clone: false,
    source: "000",
  },
  dimensions: {
    brand: process.env.REACT_APP_BRAND_CODE || 'subaru',
    country: process.env.REACT_APP_COUNTRY || 'au',
    region: process.env.REACT_APP_REGION || 'au',
    language: process.env.REACT_APP_LANGUAGE || 'en',
  },
  defaultDimensions: {
    brand: 'subaru',
    country: 'au',
    region: 'au',
    language: 'en',
  },
  endpoints: {
    template: envConfig.BE_BASE_URL +  '/part-exchange/api/v1/{lang}/templates/{id}',
    customer: envConfig.BE_BASE_URL + '/part-exchange/api/v1/customers',
    customerUpdate: envConfig.BE_BASE_URL +'/part-exchange/api/v2/customers/{id}',
    restrictedValuation: envConfig.BE_BASE_URL + '/part-exchange/api/v1/valuations/check',
    valuation: envConfig.BE_BASE_URL + '/part-exchange/api/v1/valuations/[id]',
    valuationClone: envConfig.BE_BASE_URL +'/part-exchange/api/v1/valuations/[id]/clone',
    vehicle: envConfig.BE_BASE_URL +'/part-exchange/api/v1/vehicles/[id]',
    vehicleSearchByVrn: envConfig.BE_BASE_URL +'/part-exchange/api/v1/vehicles/search-by-vrn',
    vehicleOptions: envConfig.BE_BASE_URL +'/part-exchange/api/v1/vehicles/vehicles-options',
    vehicleVrmLookup: envConfig.BE_BASE_URL +'/part-exchange/api/v1/vehicles/{vrm}',
    questionnaire: envConfig.BE_BASE_URL +'/part-exchange/api/v1/{lang}/questionnaire/{id}',
    answeredQuestionnaire: envConfig.BE_BASE_URL +'/part-exchange/api/v1/{lang}/questionnaire/{id}/{token}',
    questionnaireWithValuation: envConfig.BE_BASE_URL +'/part-exchange/api/v1/{lang}/questionnaires/{questionnaire}/with-valuation/{valuation}',
    dynamicQuestionnaire: envConfig.BE_BASE_URL +'/part-exchange/api/v1/{lang}/dynamic-questionnaire/{questionnaire}/with-valuation/{valuation}',
    dealer: envConfig.BE_BASE_URL +'/part-exchange/api/v1/dealers',
  },
  externalWidgets: {
    myAccount: {
      react: IS_DEV ? "https://cdn.jsdelivr.net/npm/react@16/umd/react.development.js" : process.env.AUTOMOTIVE_WIDGETS_REACT_BASE_URL.replace(/^$/, 'https://cdn.jsdelivr.net/npm/react@16/umd') + '/react.production.min.js',
      reactDom: IS_DEV ? "https://cdn.jsdelivr.net/npm/react-dom@16/umd/react-dom.development.js" : process.env.AUTOMOTIVE_WIDGETS_REACT_BASE_URL.replace(/^$/, 'https://cdn.jsdelivr.net/npm/react-dom@16/umd') + '/react-dom.production.min.js',
      widget: 'authentication',
      basename: '/auth',
    },
  },
  externalAssets: {
    imageNotFound: envConfig.BE_BASE_URL + '/images/image-not-available.png',
  },
  loadTemplates: {
    selector: [
      TemplateTypes.SELECT_VEHICLE,
      TemplateTypes.SEARCH_VEHICLE_VRN_AND_DETAILS,
      TemplateTypes.SEARCH_VEHICLE_VRN_ONLY,
      TemplateTypes.CAR_CONDITION_STEP,
      TemplateTypes.CUSTOMER,
      TemplateTypes.QUESTIONNAIRE_COMPONENT,
      TemplateTypes.VALUATION_NEXT,
      TemplateTypes.VALUATION,
      TemplateTypes.ERROR,
      TemplateTypes.EXCEPTION_STEP,
      TemplateTypes.RESTRICTED_VALUATION_STEP,
      TemplateTypes.DATE_COMPONENT,
    ],
    view: [
      TemplateTypes.VALUATION_VIEW
    ]
  },
  numberOfSteps: 6,
  actions: {
    saveProgress: 'save progress',
    restart: 'restart',
    resetState: 'reset state',
    prevStep: 'previous step'
  },
  dataAttribute: {
    validationMessageContainer: "data-px-validation-messages-for",
    validationMessage: "data-px-validation-message",
    tooltipContain: 'data-px-tooltip-contain',
    tooltipPointer: 'data-px-tooltip-pointer',
    tooltipPointerOver: 'data-px-tooltip-pointer-over',
    tooltipButton: "data-px-tooltip-button",
    tooltipContainer: "data-px-tooltip-container",
  },
  elementIDs: {
    defaultError: '#px_default_error',
    step1Submit: '#px_step_1_submit',
    MANUFACTURER: '[data-px-selected-manufacturer]',
    MODEL: '[data-px-selected-model]',
    BUILD_YEAR: '[data-px-selected-build-year]',
    VARIANT: '[data-px-selected-variant]',
    STATE: '[data-px-selected-state]',
    BODY: '[data-px-selected-body]',
    TRANSMISSION: '[data-px-selected-transmission]',
    FUEL: '[data-px-selected-fuel]',
    vrm: '[data-px-vrm]',
    question: 'data-px-qestr-car-question',
    QUESTIONNAIRE_CHECKBOX_CONTAINER: "data-px-qestr-checkbox-desc",
    QUESTIONNAIRE_QUESTION_ERRORS: "data-px-qestr-question-errors",
    QUESTIONNAIRE_QUESTION_ERROR_MESSAGES: "data-px-qestr-error-messages",
    QUESTIONNAIRE_QUESTION_ERROR_TYPE: "data-px-qestr-error-type",
    QUESTIONNAIRE_QUESTION_ERROR_FIELD_TYPE: "data-px-qestr-error-field-type",
    QUESTIONNAIRE_QUESTION_ERROR_FIELD_NAME: "data-px-qestr-error-field-name",
    tooltipButton: "data-px-tooltip-button",
    tooltipContainer: "data-px-tooltip-container",
    requiredErrorSelector: '[data-px-vrm-required]',
    formatErrorSelector: '[data-px-vrm-format]',
    closeErrorButton: '[data-px-button="close error"]',
    maxValuationsAcknowledge: '[data-px-action=\'maxValuationsExceeded\']',
  },
  templateQueries: {
    errorQuery: '#px-widget__step${STEP} .error',
  },
  utilityCSSClasses: {
    prefix: 'px-widget__',
    activated: 'activated',
    isHidden: 'is-hidden',
    isInvalid: 'is-invalid',
    isValid: 'is-valid',
    isVisible: 'is-visible',
    errorMessagesContainer: 'validation-message',
    submitEnabled: "px-submit",
    submitDisabled: "px-submit-disabled"
  },
  // @TODO: Refactor this with the Validator service and move these rules inside of form handlers
  // since these and the form are highly coupled.
  validationsForSteps: {
    valuation_next_step: [
      {
        inputId: '[name="preferred_dealer"]',
        eventId: 'change',
        when: { next_steps: /.*sell.*car.*/i },
        criteria: [
          {
            type: 'selected',
            errorMessageId: 'required',
          },
        ]
      },
      {
        inputId: '[name="preferred_contact_method"]',
        eventId: 'change',
        when: { next_steps: /.*sell.*car.*/i },
        criteria: [
          {
            type: 'selected',
            errorMessageId: 'required',
          },
        ]
      },
      {
        inputId: '[name="comment"]',
        eventId: 'keyup',
        when: { next_steps: /.*sell.*car.*/i },
        criteria: [
          {
            type: 'string_max_length',
            max: 2000,
            errorMessageId: 'comment_max',
          }
        ]
      },
    ]
  },
  addressState: [
    { id: "ACT", label: "Australia Capital Territory" },
    { id: "NSW", label: "New South Wales" },
    { id: "NT", label: "Northern Territory" },
    { id: "QLD", label: "Queensland" },
    { id: "SA", label: "South Australia" },
    { id: "TAS", label: "Tasmania" },
    { id: "VIC", label: "Victoria" },
    { id: "WA", label: "Western Australia" },
  ],
  questionReferences: {
    outstanding_finance_value: "amount_owing"
  }
};
